<form [action]="actionUrl" method="GET" #signInForm>
  <section  class="sign-in">
    <h4>Already Have an Account?</h4>
    <se-fe-button
      seFeDataEmphasis="low"
      seFeDataType="submit"
      (click)="signIn()"
      [seFeDataIsLoading]="signingIn">
      Sign In
    </se-fe-button>
  </section>
</form>
